// Shared "destructive trash" button used inline in card rows (Attached
// Files, Logbook). Matches the look of the image-avatar delete button
// (`.thumbnail-delete-btn` in App.css): solid red pill, white icon, with a
// tap target large enough for mobile.
//
// The inner `<i class="fa fa-trash">` is kept intentionally so existing
// tests / CSS selectors that query for it continue to match.
//
// Props:
//   onClick    — click handler
//   ariaLabel  — accessible label; defaults to "Delete"
//   className  — extra classes appended to the button

import Button from 'react-bootstrap/Button';

export const TrashButton = ({ onClick, ariaLabel = 'Delete', className = '' }) => {
  function handleClick(e) {
    // Containing rows often have their own onClick (e.g. row-click navigates
    // to file/details), so stop the bubble before invoking delete.
    e.stopPropagation();
    if (onClick) onClick();
  }

  return (
    <Button
      variant="danger"
      size="sm"
      className={`thumbnail-delete-btn ${className}`.trim()}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      <i className="fa fa-trash" aria-hidden="true"></i>
    </Button>
  );
};

export default TrashButton;
